<template>
        <v-dialog
          v-model="show"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ titulo }}</span>
            </v-card-title>
            <v-card-text>
              <base-upload-files
                folder="/documentaciones/jugadores_documentacion"
                :documento-id="documentoId"
                @documento="newFile = $event"
                :resetear="reset"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red"
                text
                @click.stop="show=false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="mode ==='edit'"
                @click="guardarDocumentacion"
              >
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        jugadorId: 0,
        documentoId: 0,
        mode: '',
        newFile: null,
        reset: false,
      }
    },
    props: {
      value: Boolean,
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      titulo: function () {
        return 'Agregar documento'
      },
    },
    watch: {

      newFile (val) {
        this.documentoId = this.newFile
      },

      mode (val) {
        this.modo = this.mode
      },
    },

    methods: {
      guardarDocumentacion: async function () {
        this.$store.dispatch('axiosMod/postData', { url: '/api/jugador_documentacion/jugador_id/' + this.jugadorId + '/documento_id/' + this.documentoId })
          .then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Documento agregado con éxito'] })
            this.$emit('close-dialog')
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        this.show = false
      },
      getJugadorId (mode, ID) {
        this.mode = mode
        if (mode === 'new') {
          this.jugadorId = ID
          this.documentoId = null
          this.newFile = null
          this.reset = !this.reset
        } else {
          this.jugadorId = ID
        }
      },
    },
  }
</script>
